import React, { useState } from "react";
import { post } from "../../utils/api";
import TextField from "@mui/material/TextField";
import forgot from "./Media/forgot.png";
import Typography from "@mui/material/Typography";
import lottie from "./Media/Contact.json";
import Lottie from "lottie-react";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [userFound, setUserFound] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setUserFound(true);
    const formForgot = e.target;
    try {
      const response = await post("/sam/doc/users/forgot-password", { email });
      if (response) {
        document.getElementById("mail-sent-modal").showModal();
        formForgot.reset(); // Reset the form here
      }
    } catch (error) {
      setUserFound(false);
      setTimeout(() => {
        setUserFound(true);
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className=" flex items-center justify-center">
        <div className="max-w-md w-full space-y-8">
          <img src={forgot} alt="" className=" w-[60%]" />
          <div>
            <Typography variant="h5" sx={{ fontWeight: "600" }} gutterBottom>
              Yo! Forgot your password?
            </Typography>
            <Typography variant="body2">
              No worries! Enter your email and we will send you a reset link.
            </Typography>
          </div>
          <form className="mt-8 " onSubmit={handleSubmit} id="forgotPassword">
            <TextField
              required
              size="small"
              id="email-address"
              name="email"
              label="📨 Email"
              variant="outlined"
              className="w-full !mb-[12px]"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <button
              type="submit"
              className="join-btn custom-btn main-button w-full"
            >
              {loading ? (
                <svg
                  className="animate-spin h-5 w-5 mr-3 text-black hover:text-white"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8zm16 0a8 8 0 01-8 8V24c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8z"
                  ></path>
                </svg>
              ) : (
                "Send Request"
              )}
            </button>
          </form>
          {userFound ? null : (
            <Typography variant="body2" sx={{ color: "red" }}>
              <span>
                <ReportGmailerrorredOutlinedIcon />
                {""}&nbsp;
              </span>
              A user with email-id <span className="italic">{email}</span> does
              not exist, Please re-check the entered email.
            </Typography>
          )}
        </div>
      </div>

      <dialog id="mail-sent-modal" className="modal ">
        <div className="modal-box modal-box-graident-border text-center  modalmy">
          <div className="main-bg p-[20px] md:p-[40px] rounded-[12px]">
            <form method="dialog">
              <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
                ✕
              </button>
            </form>
            <Lottie
              animationData={lottie}
              loop
              autoplay
              style={{
                width: "160px",
                height: "160px",
                background: "transparent",
                scale: 5,
                margin: "auto",
              }}
            />

            <Typography variant="h5" sx={{ fontWeight: "600" }} gutterBottom>
              Check your email
            </Typography>
            <p className="py-2">
              We have sent a password reset link to your email-id{" "}
              <span className="italic">{email}</span>, Please use it to change
              your password!
            </p>
          </div>
        </div>
      </dialog>
    </div>
  );
}

export default ForgotPassword;
